// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"3c09a9c4","455":"1778b042","977":"880bea3a"}[chunkId] + ".chunk.js";
};